export const SET_LOADING_PAGE = "SET_LOADING_PAGE";
export const SET_DOCUMENTOS_SOLICITADOS = "SET_DOCUMENTOS_SOLICITADOS";
export const SET_TIPOS_DOCUMENTO_SOLICITADOS = "SET_TIPOS_DOCUMENTO_SOLICITADOS";
export const SET_ACCEPT_IMAGE = "SET_ACCEPT_IMAGE";








